const React = require('react');
const ReactDOM = require('react-dom');
const classnames = require('classnames');

import Tips from '../../component/mui/tips';
import HandleInput from '../../component/mui/handle-input';
import { MaxOrderedDishCount } from '../../helper/const';
import { IntlProvider } from 'react-intl';
import FormattedMessage from '@/intl/formatted-message';
import globalMessages from '../../intl/messages/global';

import { initSingletonIntl } from '../../intl/helper';

require('./counter.scss');

module.exports = React.createClass({
  displayName: 'Counter',
  propTypes: {
    count: React.PropTypes.number.isRequired,
    maximum: React.PropTypes.number,
    minimum: React.PropTypes.number,
    step: React.PropTypes.number,
    hiddenNum: React.PropTypes.number,
    onCountChange: React.PropTypes.func.isRequired,
    onTouchTap: React.PropTypes.func,
    msg: React.PropTypes.object,
    ifShowToolTip: React.PropTypes.bool,
    showHandleInput: React.PropTypes.func,
    dishItem: React.PropTypes.object,
    showHandleDishCount: React.PropTypes.func,
    onlyAddCounter: React.PropTypes.bool,
  },
  getDefaultProps() {
    return {
      count: 0,
      minimum: 0,
      step: 1,
      hiddenNum: 0,
    };
  },
  getInitialState() {
    return {
      msg: '',
      msgRec: { bottom: -100, right: -100 },
      tooltip: false,
      tooltipText: '',
      tipInlineStyle: {},
    };
  },
  countUpdated: true, // 是否已经接收到更新的count
  componentWillMount() {
    this.tipTimeout = null;
  },
  componentWillReceiveProps(nextProps) {
    if (nextProps && this.props.count !== nextProps.count) {
      this.countUpdated = true;
      this.handleDishCount(false, false, nextProps.count, nextProps.dishItem);
    }
  },
  showToolTip(args) {
    const { tooltipText, increment } = args;
    let tipInlineStyle = {};
    const counterWidth = this.refs.counter.offsetWidth;
    const counterSingleWidth = this.refs.counteradd.offsetWidth;
    const halfCounterSingleWidth = counterSingleWidth / 2;
    let minusTriggerRight;
    const addTriggerRight = (minusTriggerRight = halfCounterSingleWidth - 5);
    const minusTipOuterRight = counterWidth - counterSingleWidth;

    if (increment > 0) {
      // 增加的提示
      tipInlineStyle = {
        tipTriggerStyle: {
          right: addTriggerRight,
        },
        tipStyle: {
          right: 0,
          borderRadius: 5,
        },
      };
    } else {
      tipInlineStyle = {
        tipOuterStyle: {
          right: minusTipOuterRight,
        },
        tipTriggerStyle: {
          right: minusTriggerRight,
        },
        tipStyle: {
          right: 0,
          borderRadius: 5,
        },
      };
    }

    this.setState(
      {
        tooltipText,
        tooltip: true,
        tipInlineStyle,
      },
      () => {
        clearTimeout(this.tipTimeout);
        this.tipTimeout = setTimeout(() => {
          this.setState({ tooltip: false });
        }, 1000);
      }
    );
  },
  onBtnsTap(evt, count, increment) {
    if (evt) {
      // 解决透传问题
      evt.preventDefault();
    }
    // 连续点两次，第二次count还未更新
    if (!this.countUpdated) {
      return;
    }

    const {
      maximum,
      minimum,
      onCountChange,
      onTouchTap,
      ifShowToolTip,
      msg = {
        maximumMsg: <FormattedMessage {...globalMessages.onLimitMax} />,
        minimumMsg: '',
      },
    } = this.props;
    const maxNumber = !maximum && maximum !== 0 ? MaxOrderedDishCount : maximum;
    if (Number(count + increment) > MaxOrderedDishCount) {
      evt.stopPropagation();
      return false;
    }

    if (onTouchTap) onTouchTap(evt);

    // 即将变更
    this.countUpdated = false;

    if (increment > 0 && maxNumber >= count + increment) {
      return onCountChange(count + increment, increment);
    } else if (increment < 0 && count + increment >= minimum) {
      return onCountChange(count + increment, increment);
    } else if (
      increment < 0 &&
      count < Math.abs(increment) &&
      !minimum
    ) {
      return onCountChange(0, increment);
    }

    // 未执行变更
    this.countUpdated = true;

    if (ifShowToolTip) {
      const tooltipText =
        increment > 0 ? msg.maximumMsg : msg.minimumMsg;
      this.showToolTip({ evt, increment, tooltipText });
      return false;
    }

    return false;
  },
  handleDishCount(evt, display, count, dishItem, shouldSendHandleDishCount) {
    if (evt) {
      evt.preventDefault();
    }
    const handleInputDOM = document.getElementById('handleInputDOM');
    const { showHandleDishCount } = this.props;

    if (
      handleInputDOM &&
      handleInputDOM.getAttribute('data-editable') === 'true' &&
      dishItem
    ) {
      // ReactDOM.render(
      //   <HandleInput dishItem={dishItem} count={count} onOrderBtnTap={this.props.onCountChange} flag={this.props.flag} display={display} />,
      //   handleInputDOM
      // );

      const intlCfg = {
        messages: window.__LANG_MESSAGES__,
        locale: sessionStorage.getItem('locale'),
      };
      initSingletonIntl(intlCfg);

      ReactDOM.render(
        <IntlProvider {...intlCfg}>
          {
            <HandleInput
              dishItem={dishItem}
              count={count}
              onOrderBtnTap={this.props.onCountChange}
              flag={this.props.flag}
              display={display}
            />
          }
        </IntlProvider>,
        handleInputDOM
      );
      if (display) {
        handleInputDOM.style.display = 'block';
      }
    }
    if (showHandleDishCount && shouldSendHandleDishCount) {
      showHandleDishCount();
    }
  },
  render() {
    const {
      count,
      step,
      maximum,
      minimum,
      hiddenNum,
      dishItem,
      onlyAddCounter,
    } = this.props;
    const { tooltip, tooltipText, tipInlineStyle } = this.state;
    const handleInputDOM = document.getElementById('handleInputDOM');

    const className = classnames('counter ', {
      'counter-max':
        count === maximum ||
        count === MaxOrderedDishCount ||
        count + step > MaxOrderedDishCount,
      'counter-min': (count <= minimum || (minimum && count <= step)) && count !== hiddenNum,
      'counter-min--nonum': count === minimum && count === hiddenNum,
      'counter--modify':
        handleInputDOM &&
        handleInputDOM.getAttribute('data-editable') === 'true' &&
        dishItem,
    });
    let countStyle;
    if (count < 10) {
      countStyle = { width: '16px' };
    } else if (count >= 10 && count <= 99) {
      countStyle = { width: '21px' };
    } else {
      countStyle = { width: '27px' };
    }
    return (
      <div className={className} ref="counter">
        {!onlyAddCounter && (
          <a className="counter-minus" ref="counterminus">
            <span
              className="counter-click-mask"
              onTouchTap={evt => this.onBtnsTap(evt, count, -step)}
            />
          </a>
        )}
        {!onlyAddCounter && (
          <span
            className="counter-num"
            style={{ minWidth: '25px', zIndex: 11 }}
            onTouchTap={evt => {
              this.handleDishCount(evt, true, count, dishItem, true);
            }}
          >
            {count}
          </span>
        )}
        <a className="counter-add" ref="counteradd">
          <span
            className="counter-click-mask"
            onTouchTap={evt => this.onBtnsTap(evt, count, step)}
            data-count={count}
          >
            {onlyAddCounter && count > 0 && (
              <span
                className="counter-click-mask--counter counter-special"
                style={countStyle}
              >
                {count > 99 ? '99+' : count}
              </span>
            )}
          </span>
        </a>
        {tooltip && tooltipText && (
          <Tips
            tipInlineStyle={tipInlineStyle}
            tooltipText={tooltipText}
            ref="tips"
          />
        )}
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/component/mui/counter.jsx